import { uniqueId } from 'lodash';
import { EditableUserInputtedConditionData, ClientDataType, EditableCondition } from '../types';

export const createBlankCondition = (
  dataType: ClientDataType,
  defaultData?: EditableUserInputtedConditionData,
): EditableCondition => ({
  ...defaultData,
  dataType,
  id: uniqueId(),
});
